import {Component, ElementRef, HostListener, Renderer2} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Meta, Title} from '@angular/platform-browser';
import {RouteData} from "../shared/services/route-data/route-data";
import {Website} from "../websites/website/website";
import {RequesterService} from "../shared/services/requester/requester.service";
import {Product} from "../websites/website/product";
import {RouteDataService} from "../shared/services/route-data/route-data.service";
import {User} from "../user/user";
import * as fromStore from '../store';
import {SwitchWorkspace} from '../store';
import {Store} from '@ngrx/store';
import {distinctUntilChanged, filter, first, switchMap} from "rxjs/operators";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {ActivityAction, ActivityStatus, IActivity} from "../activities/activity";
import {combineLatest, Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';
import {Utils} from "../shared/utils/utils";
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionIds,
  UserSubscriptionType
} from "../user/user-subscription";
import {UserService} from "../user/user.service";
import {PerformanceService} from "../websites/website/performance/performance.service";
import {WhatsNewDialogComponent} from "../websites/whats-new-dialog/whats-new-dialog.component";
import {DbResponse} from "../shared/interceptors/db-response";
import {WebsiteService} from "../websites/website.service";
import {EmailVerificationComponent} from "../account/email-verification/email-verification.component";
import {NotifierComponent} from "../shared/components/notifier/notifier.component";
import {Notification} from "../shared/components/notifier/notification";
import {NotificationType} from "../shared/components/notifier/notification-type";
import {TypeUtils} from "../shared/utils/type-utils";
import {IWorkspaceSwitcherState} from "../store/reducers/workspace-switcher.reducer";
import {RechargeComponent} from "../shared/components/dialogs/recharge-dialog/recharge.component";
import {UserManagementService} from "../user-managment/user-management.service";
import {clientRoles} from "../user/user-roles-actions";
import {AuthService} from "../auth/auth.service";
import {GlobalEvent} from "../shared/services/global-event-dispatcher/global-event";
import {GlobalEventDispatcherService} from "../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import * as websiteActions from "../store/actions/website.action";
import * as userActions from "../store/actions/user.action";
import {IWorkspaceIdEntities} from "../store/reducers/workspace.reducer";
import {TextUtils} from "../shared/utils/text-utils";
import {TypeFormAnswers} from "../add-website/typeFormAnswers";
import {ActivityNotificationService} from "../activity-notifications/activity-notification.service";
import {BuilderTemplates} from "../websites/website/builder-templates/builder-templates";
import {Config} from "../config/config";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {
  SmallScreenDisclaimerDialogComponent
} from "../shared/components/dialogs/small-screen-disclaimer/small-screen-disclaimer-dialog.component";
import {
  UnavailableDialogComponent
} from "../websites/website/plugins/plugin-download-dialog/unavailable-dialog.component";
import {DbModalService} from "../modules/modal/modal";
import {
  OptimizationDialogComponent
} from "../websites/website/booster/dialogs/optimization-dialog/optimization-dialog.component";
import {MigrationService} from "../websites/website/booster/services/migration.service";
import {OneMonthFreeComponent} from "../shared/components/dialogs/one-month-free/one-month-free.component";
import {CreateWebsiteService} from "../services/local/create-website.service";
import {
  MigrationSuccessDialogComponent
} from "../websites/add-website-dialog/migration-success-dialog/migration-success-dialog.component";
import {InformativeDialogComponent} from "../components/common/informative-dialog/informative-dialog.component";
import hostingFeatures from "../components/common/informative-dialog/features/hosting-add-on-features.json";
import {PaymentDialogComponent} from "../workspace/billing/payment-dialog/payment-dialog.component";
import {UserSubscriptionStatus} from "../user/user-subscription-status";
import {WebsiteConnectHelperService} from "../shared/services/website-connect-helper/website-connect-helper.service";
import {CookieService} from "ngx-cookie";
import {HttpClient} from "@angular/common/http";
import {Payment} from "../user/payment";
import {
  NotificationDialogComponent
} from "../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {WorkspaceService} from "../workspace/workspace.service";
import {
  ManualMigrationDialogComponent
} from "../shared/components/dialogs/migration/manual-migration-dialog/manual-migration-dialog.component";
import {DomainOfferComponent} from "../shared/components/dialogs/domain-offer/domain-offer.component";
import {BuilderHistoryService} from "../builder-v2/builder-history.service";
import {BuilderStepsEnum} from "../builder-v2/builder-tour.enum";
import {BuilderSectionsInteractionService} from "../builder-v2/builder-sections-interaction.service";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {ReCaptchaV3Service} from "ngx-captcha";
import {SidebarNavigationService} from "../shared/services/navigation/sidebar-navigation.service";

@Component({
    selector: 'db-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent {
    public Config = Config;
    public routeData: RouteData;
    public user: User;
    public userLocalStorage: any;
    public firstWebsite: Website;
    public userSubscription: UserSubscription;
    public userSubscriptionIds: any = UserSubscriptionIds;
    public loadingPage: boolean = false;
    public toggleSidebar: boolean;
    public isMobile: boolean;
    public showEmptySidebar: boolean;
    public emailCampaign: boolean = false;
    public firstTime: boolean = true;
    public toggledKnowledgeBase$: Observable<boolean>;
    public switchWorkspace$: Observable<IWorkspaceSwitcherState>;
    public currentWorkspaceRoleId: any;
    public workspaceIdEntities: IWorkspaceIdEntities;
    public currentWorkspace: any;
    public clientRoles = clientRoles;
    public chatOverlay$: Observable<boolean>;
    public UserSubscriptionType = UserSubscriptionType;
    public userSubscriptionStatus = UserSubscriptionStatus;
    public isOwnWorkspaceActive: boolean;
    public websiteSidebarToggle$: Observable<boolean>;
    public showDisclaimer: boolean;
    public openChatFirstTime: boolean;
    public ongoingBoosterActivity: boolean = false;
    public ongoingActivity$: Observable<IActivity[]>;
    public openLiveChat: boolean = false;
    public sendChatMessage: boolean = false;
    public sendMessage: string;
    public sendTag: string;
    public hostingAddOnFeatures = hostingFeatures;
    public connectedWebsiteId: number;
    public showUltimateOffer: boolean = false;
    public annualSubscription: UserSubscription;
    public monthlyPrice: number;
    public annualPriceForCurrent: number;
    public userLoading$: Observable<boolean>;
    public userSubscriptionLoading$: Observable<boolean>;
    public payments: Payment[];
    public isGeo: boolean;
    public countryName: string;
    public previewUrl: string;
    prefilledAi: any;
    public demoUser: boolean = false;
    campaignForGeneration: boolean = false;
    downgradedToBase: boolean = false;
    protected readonly Utils = Utils;
    protected readonly UserSubscriptionCategory = UserSubscriptionCategory;
    private invitationData: any;
    private invitationDataUnEncoded: any;
    private invitationProductId: number;
    private invitationPeriod: string;
    private typeFormAnswers = TypeFormAnswers;
    private getExperimentalCookie: any;

    constructor(
        public builderHistoryService: BuilderHistoryService,
        private _router: Router,
        private _route: ActivatedRoute,
        private _routeDataService: RouteDataService,
        private _store: Store<fromStore.DbStoreState>,
        private _requester: RequesterService,
        private _dialogService: DialogService,
        private _performanceService: PerformanceService,
        private _userService: UserService,
        private _websiteService: WebsiteService,
        private _userManagementService: UserManagementService,
        private _authService: AuthService,
        private _globalEventDispatcher: GlobalEventDispatcherService,
        private _googleAnalyticsService: GoogleAnalyticsService,
        private _dbModalService: DbModalService,
        private _createWebsiteService: CreateWebsiteService,
        public readonly _websiteConnectHelperService: WebsiteConnectHelperService,
        private _cookieService: CookieService,
        private _reCaptchaV3Service: ReCaptchaV3Service,
        private elRef: ElementRef,
        private renderer: Renderer2,
        private sidebarNavigationService: SidebarNavigationService,
        private _meta: Meta,
        private _title: Title,
        private _builderInteractionsService: BuilderSectionsInteractionService
    ) {
        this.chatOverlay$ = this._store.select(fromStore.getChatOverlaySectionToggled);
        this.toggledKnowledgeBase$ = this._store.select(fromStore.getKnowledgeBaseToggled);
        this.websiteSidebarToggle$ = this._store.select(fromStore.getWebsiteSidebarToggled);
        this.switchWorkspace$ = this._store.select(fromStore.getWorkspaceSwitching);
        this.switchWorkspace$.subscribe((switchWorkspace: any) => {
            if (!switchWorkspace.switching) {
                this.waitUntilUserLoaded(false);
            }
        });
        this.routeData = this._routeDataService.getCurrentRouteData();
        this._router.events
            .pipe(
                filter((event: any) => event instanceof NavigationEnd)
            )
            .subscribe((event) => {
                if (this._route.snapshot.queryParams['showPreview'] && !this._checkStorageIframeOpened()) {
                    this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {
                        showIframe: true,
                    });
                }
                this.routeData = this._routeDataService.getCurrentRouteData();
                this.setToggle(false);
            });

        window.onblur = (): void => {
            this._requester.clearCache();
        };

        /* open chat */
        this._openLiveChat();

        /* invitation Data */
        this.inviteData();

        /* show article with id in knowledge base */
        this.showArticleInKnowledgeBase();

        /* get booster ongoing steps */
        this._getBoosterOngoingSteps();

        /* check from_local */
        this.fromLocalInUrl();

        /* wait until User Loaded */
        this.waitUntilUserLoaded();
        this.checkOwnWebsiteStatus();
        this._store.dispatch(new fromStore.InitStore());
        this._globalEventDispatcher.addEventListener(GlobalEvent.connectWebsite, isLoading => {
            this.loadingPage = isLoading;
        });

        // Subscribe to sidebar visibility changes from the service
        this.sidebarNavigationService.isSidebarVisible.subscribe(isVisible => {
            this.toggleSidebar = isVisible;
        });
        this.getRegenerationCount();
    }

    get hasGlobalBanner(): boolean {
        return false;
        /*return !!this.user &&
          !this.userSubscription?.isDedicatedVM &&
          this.currentWorkspaceRoleId === this.clientRoles.OWNER &&
          this.userSubscription?.isAgency &&
          !this.userSubscription?.isApiResellerPlan &&
          this.userSubscription?.plan?.shortFeatures?.variant === 'b' &&
          this.routeData &&
          !['checkout', 'sign-up', 'login'].includes(this.routeData?.pageId);*/
    }

    @HostListener('window:resize') resize() {
        this.isMobile = window.innerWidth < 1679;
        this.showEmptySidebar = window.innerWidth <= 1024;
    }

    ngOnInit(): void {
        const queryParams: any = (<any>this._route.queryParams).value;
        queryParams && queryParams.prefilledAiData && (this.prefilledAi = true);
        (queryParams.showPaypal || new URL(window.location.href).searchParams.get("showPaypal")) && localStorage.setItem('showPaypal', 'true');
        let magicData = queryParams.magic_data || new URL(window.location.href).searchParams.get("magic_data") || null;
        if (magicData && !localStorage.getItem('dbUserAccessToken')) {
            const urlObj = new URL(window.location.href);
            const path = urlObj.pathname;
            const searchParams = urlObj.searchParams;
            const _queryParams = {};

            for (const [key, value] of searchParams) {
                !['magic_data', 'email'].includes(key) && (_queryParams[key] = value);
            }
            magicData = Utils.b64DecodeUnicode(magicData);
            if (magicData.magic_token && magicData.email) {
                this._authService
                    .recaptchaEnv()
                    .pipe(
                        filter((response: DbResponse): boolean => !!response),
                        first()
                    )
                    .subscribe((response) => {
                        if (response.success) {
                            const recaptchaMode = response.data.recaptcha_mode.value === "live";
                            if (!!recaptchaMode) {
                                this._reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (recaptchaToken) => {
                                    path && this.loginFromMagicLink(magicData.magic_token, magicData.email, path, _queryParams, recaptchaToken);
                                });
                            } else {
                                path && this.loginFromMagicLink(magicData.magic_token, magicData.email, path, _queryParams);
                            }
                        }
                    });
            }
        }
        this.userLoading$ = this._store.select(fromStore.getUserLoading);
        this.userSubscriptionLoading$ = this._store.select(fromStore.getUserSubscriptionLoading);
        this.isMobile = window.innerWidth < 1679;
        this.showEmptySidebar = window.innerWidth <= 1024;
        const hasMagicLink = new URL(window.location.href).searchParams.get("magicLink");
        this.campaignForGeneration = !!(new URL(window.location.href).searchParams.get("dbDemoCampaign"));
        this.campaignForGeneration && localStorage.setItem('dbDemoCampaign', '1');
        const freeDays = new URL(window.location.href).searchParams.get("ct");
        const discount = new URL(window.location.href).searchParams.get("cd");
        const info = (freeDays ? 'ct' + freeDays : '') + (discount ? 'cd' + discount : '');
        (freeDays || discount) && localStorage.setItem('dbDemoCampaignInfo', info);
        this.emailCampaign = !!(new URL(window.location.href).searchParams.get("emailCampaign"));
        const dbCouponFromEmail = new URL(window.location.href).searchParams.get("dbCouponFromEmail");
        !!dbCouponFromEmail && dbCouponFromEmail.indexOf(Config.popupCouponPrefixForAutoApply) > -1 && localStorage.setItem('dbCouponFromEmail', dbCouponFromEmail);
        this._checkUrlForVerification();
        this._updateMetaTags();
    }

    ngAfterViewInit() {
        const handleInputs = () => {
            const dsInputs = this.elRef.nativeElement.querySelectorAll('.ds-input, .ds-input-black');

            const inputs = dsInputs.length > 0 ? dsInputs : this.elRef.nativeElement.querySelectorAll('input, textarea');

            if (inputs.length > 0) {
                inputs.forEach((input: HTMLElement) => {
                    // Disable zoom on the first focus
                    this.renderer.listen(input, 'focus', () => this.disableZoom());
                    this.renderer.listen(input, 'touchstart', () => this.disableZoom());
                });
            }
        };

        handleInputs();

        setTimeout(handleInputs, 1000);

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach((node) => {
                        if (node instanceof HTMLElement) {
                            const newInputs = node.querySelectorAll('.ds-input, .ds-input-black, input, textarea');
                            newInputs.forEach((input: HTMLElement) => {
                                this.renderer.listen(input, 'focus', () => this.disableZoom());
                                this.renderer.listen(input, 'touchstart', () => this.disableZoom());
                            });
                        }
                    });
                }
            });
        });

        observer.observe(this.elRef.nativeElement, {
            childList: true,
            subtree: true
        });

        setTimeout(handleInputs, 3000);
    }

    disableZoom() {
        const viewport = document.querySelector("meta[name=viewport]");
        if (viewport) {
            viewport.setAttribute(
                'content',
                'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
            );
        }
    }

    public waitUntilUserLoaded(firstTimeLoad: boolean = true): void {
        const distinctKeys = ['id', 'oneProductOrBundleClient', 'additionalWebsiteCount', 'hasHostingTrial', 'hostingTrialExpired', 'planType', 'category'];
        this._store.select(fromStore.getUserLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => this._store.select(fromStore.getUser)),
                distinctUntilChanged((u1: User, u2: User) => u1 && u2 && JSON.stringify(u1, distinctKeys) === JSON.stringify(u2, distinctKeys) || firstTimeLoad),
                filter((user: User) => {
                    return !!user;
                }),
                switchMap(() =>
                    combineLatest(
                        this._store.select(fromStore.getUserLoaded),
                        this._store.select(fromStore.getUserLocalStorageLoaded),
                        this._store.select(fromStore.getWebsitesLoaded)
                    )
                        .pipe(
                            filter(([userLoaded, userLocalStorageLoaded, websitesLoaded]) => userLoaded && userLocalStorageLoaded && websitesLoaded),
                            switchMap(() => combineLatest(
                                this._store.select(fromStore.getUser),
                                this._store.select(fromStore.getUserSubscription),
                                this._store.select(fromStore.getUserLocalStorage),
                                this._store.select(fromStore.getWorkspaceIdEntities),
                                this._store.select(fromStore.getCurrentWorkspace),
                                this._store.select(fromStore.getWebsites),
                                this._store.select(fromStore.getPayments),
                                this._store.select(fromStore.getUserAvailableHostingSubscriptions('platform')),
                                this._store.select(fromStore.getUserMeta())
                            )),
                            first()
                        )
                )
            )
            .subscribe(([user, userSubscription, userLocalStorage, workspaceIdEntities, currentWorkspace, websites,
                            payments, availableSubscriptions, meta]) => {
                // welcome dialog
                this.demoUser = Utils.isDemoUser(userSubscription, user);
                const queryParams: any = (<any>this._route.queryParams).value;
                const subscriptionId: number = parseInt(queryParams.subscr_id, 10);
                const fromFreePlugin: boolean = !!queryParams.from_free_plugin;
                this.workspaceIdEntities = workspaceIdEntities;
                this.currentWorkspaceRoleId = this.workspaceIdEntities && this.workspaceIdEntities.currentWorkspaceRoleId;
                this.currentWorkspace = currentWorkspace;
                const websiteConnectedId = new URL(window.location.href).searchParams.get("website_connected") || queryParams.website_connected;
                const showUltimateOffer = new URL(window.location.href).searchParams.get("show_ultimate_offer") || queryParams.show_ultimate_offer;
                this.showUltimateOffer = TypeUtils.isDefined(showUltimateOffer) && Utils.isTruthy(showUltimateOffer);
                this.connectedWebsiteId = Number(websiteConnectedId);
                this.payments = payments;
                const manual = queryParams.manual || window.location.href.indexOf("manual") > -1;
                const showUpgradePopup = queryParams.showUpgradePopup || window.location.href.indexOf("showUpgradePopup") > -1;

                if (manual && !this._dialogService.hasOpenedDialog() && !this._dbModalService.hasOpenModals()) {
                    this._dialogService.addDialog(ManualMigrationDialogComponent, {ErrMessage: true});
                }
                const introduceHostingFromEmail = queryParams.introduce_hosting_from_email || window.location.href.indexOf("introduce_hosting_from_email") > -1;

                /*GENERATE DEMO*/
                if (localStorage.getItem('dbDemoCampaign') && !this.downgradedToBase && user && userSubscription?.hostingTrialExpired && this.builderHistoryService.downgradedToBase.value === false) {
                    this._downgradeToStarterPlan('base');
                }

                /*SET DEMO SITE URL IN IFRAME*/
                const dbTesting: boolean = !!this._cookieService.get('db-testing');
                let website;
                if (this.demoUser) {
                    website = websites.find(website => website?.isAiBuilderDemo);
                    const previewUrl = website && `${website.site_url}?from=websites&client_id=${user?.id}&domain_id=${Config.demoDomainId}&first_time` + (dbTesting ? `&db-testing` : ``);
                    website && (userSubscription?.freeBaseClient || userSubscription?.trialClient) &&
                    this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {
                        showIframe: this._checkStorageIframeOpened(),
                        iframeUrl: previewUrl
                    });
                }

                /*SET DEMO SITE URL IN IFRAME*/

                if (introduceHostingFromEmail && !this.connectedWebsiteId && !this._dialogService.hasOpenedDialog()
                    && !this._dbModalService.hasOpenModals()) {
                    this._hostingAddOnDialogShow(websites);
                }

                if (meta && meta['country_code'] && meta['country_code'].length) {
                    this.countryName = meta['country_code'][0];
                }

                this.isGeo = this.countryName === 'IN';

                this.user = user;
                /*TODO SAILFISH*/
                /*
                        identify(this.user?.id);
                */
                this.userSubscription = userSubscription;
                userSubscription && !userSubscription?.freeBaseClient && !userSubscription?.trialClient && localStorage.getItem('dbCouponFromEmail') && !localStorage.getItem('dbCouponFromEmail').includes(Config.couponPrefixForExtendWithCouponDowngrade)
                && localStorage.removeItem('dbCouponFromEmail');
                const category = this.userSubscription && this.userSubscription.isBusiness ? UserSubscriptionCategory.ENTERPRISE : UserSubscriptionCategory.PREMIUM;
                this.annualSubscription = availableSubscriptions.find(userSubscription =>
                    userSubscription && this.userSubscription && userSubscription.category && userSubscription.category === category
                    && userSubscription.tabCategory && userSubscription.tabCategory === this.userSubscription.tabCategory
                    && userSubscription.plan && userSubscription.plan.periodNumber && userSubscription.plan.periodNumber === 12
                );

                if (this.userSubscription && this.userSubscription.platformPaidClient) {
                    const currentAnnualPlan = availableSubscriptions.find(userSubscription =>
                        userSubscription && userSubscription.plan && userSubscription.id === Number(this.userSubscription.coupleId) && userSubscription.category === this.userSubscription.category &&
                        userSubscription.plan.periodNumber === 12
                    );
                    this.annualPriceForCurrent = currentAnnualPlan && currentAnnualPlan.plan && currentAnnualPlan.plan.price;
                }
                const monthlySubscription = availableSubscriptions.find(userSubscription =>
                    userSubscription && this.userSubscription && userSubscription.category && userSubscription.category === category
                    && userSubscription.tabCategory && userSubscription.tabCategory === this.userSubscription.tabCategory
                    && userSubscription.plan && userSubscription.plan.periodNumber && userSubscription.plan.periodNumber === 1
                );
                this.monthlyPrice = monthlySubscription && monthlySubscription.plan && monthlySubscription.plan.planPrice;

                this.userLocalStorage = userLocalStorage;
                this.getExperimentalCookie = this._cookieService.get('db-experiment');
                const cookieData = TypeUtils.isValidJSON(this.getExperimentalCookie) ? JSON.parse(this.getExperimentalCookie) : {};


                if ((this.isGeo)) {
                    if (cookieData && cookieData.hasOwnProperty('gPExp')) {
                        this._removeFromCookieValue(this.getExperimentalCookie, 'gPExp', false);
                    }
                }

                if (this.countryName && this.userSubscription && this.userSubscription.category === UserSubscriptionCategory.STARTER && (TypeUtils.isNull(userLocalStorage.tier1B) || TypeUtils.isUndefined(userLocalStorage.tier1B))) {
                    this.userLocalStorage['tier1B'] = Config.englishCountries.includes(this.countryName);
                    this._userService.setToLocal(this.userLocalStorage)
                        .pipe(
                            first(response => !!response),
                        )
                        .subscribe(response => {
                            if (response.success) {
                                this._store.dispatch(new fromStore.LoadUserLocalStorage());
                            }
                        });
                }

                if (this.countryName && this.userSubscription && this.userSubscription.category === UserSubscriptionCategory.STARTER
                    && !TypeUtils.isNull(userLocalStorage.tier1B) && !TypeUtils.isUndefined(userLocalStorage.tier1B) && Utils.isTruthy(this.userLocalStorage['tier1B']) && Config.countryList.includes(this.countryName)) {
                    this.userLocalStorage['tier1B'] = false;
                    this._userService.setToLocal(this.userLocalStorage)
                        .pipe(
                            first(response => !!response),
                        )
                        .subscribe(response => {
                            if (response.success) {
                                this._store.dispatch(new fromStore.LoadUserLocalStorage());
                            }
                        });
                }


                if (this.userSubscription && cookieData?.hasOwnProperty('ecommerceExp')) {
                    this._removeFromCookieValue(this.getExperimentalCookie, 'ecommerceExp', false);
                }

                if (((Config.countryList.includes(this.countryName) || !this.countryName) && this.userSubscription) || (Config.englishCountries.includes(this.countryName) && this.userSubscription && this.userSubscription.trialClient)) {
                    if (cookieData?.hasOwnProperty('t1PExp')) {
                        if (this.userSubscription && !this.userSubscription.trialClient) {
                            this._setLocalTier1(cookieData['t1PExp']);
                        }
                        this._removeFromCookieValue(this.getExperimentalCookie, 't1PExp', false);
                    }
                }

                if (this.userSubscription && this.userSubscription.trialClient) {
                    if (cookieData.hasOwnProperty('pExp')) {
                        this._removeFromCookieValue(this.getExperimentalCookie, 'pExp', false);
                    }
                }
                if (!this.demoUser && userSubscription?.platformPaidClient) {
                    if (cookieData?.hasOwnProperty('onewfPlanSelection')) {
                        this._removeFromCookieValue(this.getExperimentalCookie, 'onewfPlanSelection', false);
                    }
                    if (cookieData?.hasOwnProperty('businessAIPremiumPlan')) {
                        this._removeFromCookieValue(this.getExperimentalCookie, 'businessAIPremiumPlan', false);
                    }
                    if (cookieData?.hasOwnProperty('onewfPlanInclusions')) {
                        this._removeFromCookieValue(this.getExperimentalCookie, 'onewfPlanInclusions', false);
                    }
                    const hasResurrectionCoupon = this._cookieService.get('dbCouponFromEmail');
                    if (hasResurrectionCoupon) this._cookieService.remove('dbCouponFromEmail');
                }

                if (cookieData?.hasOwnProperty('showTexts')) {
                    this._removeFromCookieValue(this.getExperimentalCookie, 'showTexts', false);
                }
                if (cookieData?.hasOwnProperty('hubspot')) {
                    this._removeFromCookieValue(this.getExperimentalCookie, 'hubspot', false);
                }

                if (this.user && Utils.checkDevice() && window.innerWidth <= 1024 && userLocalStorage && !userLocalStorage.hideDisclaimer && this.user.subscriptionId === Config.defaultStarterPlanId && !this.user.hostingTrialExpired && !this.showDisclaimer && !showUpgradePopup) {
                    this.showDisclaimer = true;
                    /*          this.showSmallScreenDisclaimerDialog(userLocalStorage);*/
                }

                const openChat = queryParams.open || window.location.href.indexOf("open") > -1;
                if (openChat && !this.openChatFirstTime) {
                    this.openChat();
                }

                if (!this._dialogService.hasOpenedDialog() && !this._dbModalService.hasOpenModals()
                    && firstTimeLoad && window.location.pathname
                    && !window.location.pathname.includes('setup') && !window.location.pathname.includes('onboarding')
                    && !window.location.pathname.includes('paypal-waiting')
                    && ((userLocalStorage && !userLocalStorage.oneMFOffer && (new Date(user.createdAt).getTime() + 2 * 24 * 60 * 60 * 1000) <= new Date().getTime()) || (userLocalStorage && userLocalStorage.oneMFOffer
                        && new Date(userLocalStorage.oneMFOffer).getTime() + (4 * 24 * 60 * 60 * 1000) <= new Date().getTime()))
                    && (user.websiteCreated || user.websiteConnected) && user.subscriptionId === Config.defaultStarterPlanId) {
                    this._sendAnalytics((this.demoUser ? 'Free Upgrade Offer' : 'Free trial paywalls'), 'Locked button click', 'Dashboard: Automatic popup ');
                    const oneMFOfferCount: number = userLocalStorage.oneMFOfferCount || 0;
                    if (this.demoUser) {
                        const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
                        const options = {
                            overflowHidden: false,
                        };
                        if (!firstTime) {
                            options['width'] = 1240;
                        } else {
                            options['width'] = 460;
                            options['height'] = 600;
                        }
                        const modal = this._dbModalService.open(OneWeekFreeDemoUpgradeComponent, options);
                        modal.componentInstance.showFirstTime = firstTime;
                        modal.closed.subscribe(() => {
                            this._userService.setToLocal({
                                ...userLocalStorage,
                                oneMFOffer: new Date(),
                                oneMFOfferCount: oneMFOfferCount + 1
                            });
                        });
                        modal.dismissed.subscribe(() => {
                            this._userService.setToLocal({
                                ...userLocalStorage,
                                oneMFOffer: new Date(),
                                oneMFOfferCount: oneMFOfferCount + 1
                            });
                        });
                    } /*else {
            const modal = this._dbModalService.open(OneMonthFreeComponent, {height: 600, width: 940});
            modal.componentInstance.mode = 'feature';
            modal.closed.subscribe(() => {
              this._userService.setToLocal({
                ...userLocalStorage,
                oneMFOffer: new Date(),
                oneMFOfferCount: oneMFOfferCount + 1
              });
            });
            modal.dismissed.subscribe(() => {
              this._userService.setToLocal({
                ...userLocalStorage,
                oneMFOffer: new Date(),
                oneMFOfferCount: oneMFOfferCount + 1
              });
            });
          }*/
                }
                const _isMobile = window.innerWidth <= 991;
                /*      !this.domainOfferOpened
                      && !this.emailCampaign
                      && !afterOnboarding
                      && !showUpgradePopup
                      && !showRegeneratePopup
                      && !_isMobile
                      && !showFinalize
                      && !localStorage.getItem('domainOfferSeen' + this.user?.id)
                      && !localStorage.getItem('showBuilderV2Finalize')
                      && [clientRoles.OWNER].includes(this.currentWorkspace.roleId)
                      && !userLocalStorage?.domainOfferSeen && this._showDomainOffer();*/

                /** Accept invitation to workspace for existing clients*/
                this.acceptInvitationExcistingClients();

                // first Time Load functions
                if (firstTimeLoad) {
                    this.firstTimeLoadFunctions(websites, subscriptionId, fromFreePlugin, manual, queryParams);
                }
                this._showCycleChangedSuccess(queryParams, this.userSubscription && this.userSubscription.plan && this.userSubscription.plan.price);
            });
        this.getRegenerationCount();
    }

    public checkOwnWebsiteStatus() {
        this._store.select(fromStore.getUserLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => this._store.select(fromStore.getOwnerWorkspace)),
            )
            .subscribe((ownWorkspace) => {
                this.isOwnWorkspaceActive = ownWorkspace && !['invited'].includes(ownWorkspace.status);
            });
    }

    public firstTimeLoadFunctions(websites, subscriptionId, fromFreePlugin, manual, queryParams): void {

        /** show download plugins if from_local param exists */
        localStorage.getItem('fromLocal') && this._showDownloadPluginsDialog();

        /*Accept invitation to workspace for existing clients*/
        this.acceptInvitationExcistingClients();

        /* todo commented zendesk auth fail dialog call */
        /*Show zendesk auth failed dialog
        this.showZendeskAuthFailedDialog(); */

        this.migrationSuccessDataMapper(websites);
        this.firstWebsite = websites && websites[0];

        this.firstWebsite && this.goToOnboardingPage(this.firstWebsite.id);

        if (this.currentWorkspaceRoleId && ![clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspaceRoleId)
            && this.userSubscription && this.userSubscription.recharge
            && this.routeData && this.routeData.pageId !== "paypal-waiting" && window.location.href.indexOf("paypal-waiting") <= -1) {
            const modal = this._dbModalService.open(RechargeComponent, {height: 208, width: 700});
            modal.componentInstance.userSubscription = this.userSubscription;
        }

        if (this.user && (!this.user.hasHostingTrial || (this.user.hasHostingTrial && this.user.hostingTrialExpired))) {
            localStorage.removeItem('showConnectBanner' + this.user.id);
        }

        /* lucky orange */
        this.luckyOrange();

        /* whats new dialog */
        this.showWhatsNewDialog(this.user);

        /* after redirect back from WP */
        this._websiteConnectHelperService.handleConnection(this.connectedWebsiteId, null);
        // TODO remove
        /* actions after connect website */
        // this.actionsWithConnectedWebsite(websiteIdConnected, subscriptionId, fromFreePlugin, connectedWebsite,
        //   new URL(window.location.href).searchParams.get("from_plugin") === '10webspeedoptimizer' || queryParams.from_plugin === '10webspeedoptimizer');

        /* email verification */
        this.emailVerification(queryParams);

        /* get ongoing activities while creating website */
        this.getOngoingActivitiesCreateWebsite(manual);

        /* auto update manager and services */
        this.pluginsUpdate(websites);

        /* show switch Plan to Annual Dialog */
        this._showSwitchPlanToAnnualDialog(queryParams);

    }

    getRegenerationCount() {
        this._store.select(fromStore.getWebsitesLoaded)
            .pipe(
                first(loaded => loaded),
                switchMap(() =>
                    this._store.select(fromStore.getGeneratedWebsitesCount)
                ),
            )
            .subscribe((generateWebsiteCount: any) => {
                if (this.userSubscription?.apiResellerPro && (generateWebsiteCount || generateWebsiteCount === 0)
                    && this.userSubscription.plan.services.ai_builder) {
                    const baseGenerationsCount = parseInt(
                            this.userSubscription?.plan?.additionalDomainCount &&
                            this.userSubscription?.plan?.services?.ai_builder.regeneration_additional_count ?
                                this.userSubscription?.plan?.services?.ai_builder.regeneration_additional_count.parameter_value : 0, 10)
                        * this.userSubscription?.plan?.additionalDomainCount;
                    const baseGenerationsCountWithoutAddOn = parseInt(this.userSubscription.plan.services.ai_builder.regeneration_count.parameter_value, 10);
                    const usedExtra = generateWebsiteCount - (baseGenerationsCount + baseGenerationsCountWithoutAddOn);

                    // Safe assignment with null check
                    if (this.userSubscription && this.userSubscription.plan) {
                        this.userSubscription.plan.usedMultiplierRegenCount = usedExtra;
                    }

                    if (this.userSubscription.plan.aiBuilderService && this.userSubscription.plan.usedMultiplierRegenCount > 0) {
                        const price = parseInt(this.userSubscription.plan?.aiBuilderService?.regeneration_count?.parameter_price, 10);
                        const count = Number(this.userSubscription.plan?.aiBuilderService?.regeneration_count?.parameter_value);
                        this.userSubscription.plan.usedMultiplierRegenPrice = this.userSubscription.plan.usedMultiplierRegenCount * (price / count);
                    } else {
                        this.userSubscription.plan.usedMultiplierRegenPrice = 0;
                    }
                }
            });
    }

    public openChat(sendText?, addedTags?): void {
        this.openChatFirstTime = true;

        window['Smooch']?.open();
        /* window['zE']('messenger', 'chat:send', 'Open LiveChat');*/
    }

    public luckyOrange(): void {
        if (environment.enableLuckyOrange) {
            const customData = {
                'name': this.user && (this.user.firstName + ' ' + this.user.lastName),
                'email': this.user && this.user.email,
                'userID': this.user && this.user.id
            };

            window['_loq'] = window['_loq'] || [];
            try {
                window['_loq'].push(['custom', customData]);
                window['_loq'].push(['tag', 'logged-in']);
            } catch (e) {
                console.log(e, typeof window['_loq']);
            }
        }
    }

    public getOngoingActivitiesCreateWebsite(manual): void {
        this._store.select(fromStore.getCreateWebsiteOngoingActivity)
            .pipe(
                filter(activity => !!activity),
                distinctUntilChanged((prev, curr) => prev && curr && prev.id === curr.id),
                switchMap(() => combineLatest(
                    this._store.select(fromStore.getMigrationOngoingActivity),
                    this._store.select(fromStore.getCreateWebsiteOngoingActivity)
                ))
            )
            .subscribe(([migrationActivity, createActiivity]) => {
                this.getActivity(migrationActivity, createActiivity, manual);
            });
    }

    public getActivity(migrationActivity, createActivity, manual): void {
        if (migrationActivity) {
            window['_loq'] = window['_loq'] || [];
            try {
                window['_loq'].push(['tag', 'migrate']);
            } catch (e) {
                console.log(e, typeof window['_loq']);
            }
        }

        if ((this.routeData && ['reset-password', 'email-preferences'].includes(this.routeData.pageId))) {
            return;
        }
        if (this._dialogService.hasOpenedDialog() || this._dbModalService.hasOpenModals()) {
            return;
        }

        // if (((migrationActivity || manual) && !websiteIdConnected)
        //   || (createActiivity && createActiivity.status === 'running' && createActiivity.progress !== 100)) {
        //   this.showAddWebsiteDialog(this.user.id, this.user.firstName, migrationActivity, manual, false);
        // }
        /*if (migrationActivity && !websiteIdConnected) {
          this._createWebsiteService.openMigrateWebsiteModal(migrationActivity.websiteId, true);
        }*/
        /*if (manual && !websiteIdConnected) {
          const modal = this._dbModalService.open(ManualMigrateWebsiteComponent, {backdrop: 'static'});
          modal.componentInstance.isAutoMigrationFailed = true;
        }*/
    }

    public _getBoosterOngoingSteps(): void {
        if (window.location.href.indexOf("optimizing_website") > -1) {
            const optimizingWebsiteId = new URL(window.location.href).searchParams.get("optimizing_website");
            this._getConnectionFlowStep(optimizingWebsiteId);
        } else {
            this._getOngoingOptimizingActivities();
        }
    }

    public goToOnboardingPage(websiteId): void {
        if (this.firstTime && this.user && this.user.signUpFor && this.user.signUpFor.CreationOption && this.user.signUpFor.CreationOption.id && [this.typeFormAnswers.DESIGNER_MADE_TEMPLATE, this.typeFormAnswers.BUILD_WITH_TENWEB_IO].includes(this.user.signUpFor.CreationOption.id) && this.userSubscription.trialClient && this.user.websiteCreated === 1 && this.routeData && this.routeData.pageId !== "paypal-waiting") {
            this._store.select(fromStore.getLastBuilderTemplate(websiteId))
                .subscribe((builderTemplate: BuilderTemplates) => {
                    if (typeof builderTemplate === 'object' && builderTemplate !== null) {
                        const recreationFlow = !TypeUtils.isUndefined(builderTemplate.ever_recreated) && !Utils.isTruthy(builderTemplate.ever_recreated) && this.user.signUpFor && this.user.signUpFor.CreationOption && this.user.signUpFor.CreationOption.id === this.typeFormAnswers.BUILD_WITH_TENWEB_IO;
                        const templateImportFlow = TypeUtils.isUndefined(builderTemplate.id) && this.user.signUpFor && this.user.signUpFor.CreationOption && this.user.signUpFor.CreationOption.id === this.typeFormAnswers.DESIGNER_MADE_TEMPLATE;
                        if (recreationFlow) {
                            this.firstTime = false;
                            this._router.navigate(['/websites/' + websiteId + '/onboarding/onboarding-recreate-website']);
                        } else if (templateImportFlow) {
                            this.firstTime = false;
                            this._router.navigate(['/websites/' + websiteId + '/onboarding/onboarding-templates']);
                        }
                    }
                });
        }
    }

    public pluginsUpdate(websites): void {
        websites
            .filter((website: Website): boolean => website.isActive && !website.isLocalhost && website.connectedFrom !== 'speed_optimizer')
            .forEach((website: Website): void => {
                const websiteId = website.isNetwork && !website.parentId ? website.children[0] : website.id;
                this._store.select(fromStore.getWebsitePluginsLoaded(websiteId))
                    .pipe(
                        first(loaded => loaded, null),
                        switchMap(() => this._store.select(fromStore.getWebsiteManagerPlugin(websiteId))),
                        first()
                    )
                    .subscribe(product => this.pluginUpdate(product, website));
            });
    }

    public pluginUpdate(product, website): void {
        if (product && product.updateAvailable) {
            this._store.dispatch(new fromStore.InitWebsiteProductAction({
                website: website,
                products: [product],
                action: ActivityAction.UPDATE,
                network: 1
            }));
        }
    }

    public inviteData(): void {
        const queryParams: any = (<any>this._route.queryParams).value;
        this.invitationData = !new URL(window.location.href).searchParams.get("sign-up") ? (queryParams.invitation_data || new URL(window.location.href).searchParams.get("invitation_data")) : null;
        if (this.invitationData) {
            this.invitationDataUnEncoded = this.invitationData;
            this.invitationData = Utils.b64DecodeUnicode(this.invitationData);
            this.invitationProductId = queryParams.product_id ? parseInt(queryParams.product_id, 10) : null;
            this.invitationPeriod = queryParams.period || null;
        }
    }

    public showArticleInKnowledgeBase() {
        const articleId = new URL(window.location.href).searchParams.get("show_article");
        if (articleId) {
            this._store.dispatch(new fromStore.ToggleKnowledgeBase({
                articleId: articleId,
                scrollToEl: ''
            }));
        }
    }

    public fromLocalInUrl(): void {
        if (localStorage.getItem("fromLocal") === null && window.location.href.indexOf("from_local") > -1) {
            localStorage.setItem('fromLocal', "true");
        }
    }

    public switchToWorkspace(workspaceId: number | string, switchToWorkspace?: any): void {
        this._userManagementService.switchWorkspace(workspaceId)
            .pipe(
                filter(response => !!response),
                first()
            )
            .subscribe(response => {
                if (response.success) {
                    if (TypeUtils.isDefined(switchToWorkspace)) {
                        this._store.dispatch(new fromStore.SetWorkspaceIdEntities(
                            {
                                ownerWorkspaceId: switchToWorkspace.ownerWorkspaceId,
                                currentWorkspaceId: switchToWorkspace.currentWorkspaceId,
                                currentWorkspaceRoleId: switchToWorkspace.currentWorkspaceRoleId,
                                globalEventDispatcherService: this._globalEventDispatcher
                            }
                        ));

                        this._store.dispatch(new userActions.LoadUser());
                        this._store.dispatch(new userActions.LoadUserSubscription());
                        this._store.dispatch(new userActions.LoadUserAvailableSubscriptions());
                        this._store.dispatch(new SwitchWorkspace({
                            switching: false,
                            workspaceName: '',
                            redirect: true
                        }));
                        this._store.dispatch(new websiteActions.ClearWebsites());
                        this._store.dispatch(new websiteActions.LoadWebsites());
                    } else {
                        this._globalEventDispatcher.dispatchEvent(GlobalEvent.workspaceSwitch);
                    }
                    this._router.navigate(['/websites']);
                }
            });
    }

    public touchMove(): void {
        if (this.isMobile) {
            // jQuery('body').bind('touchmove', function (e) {
            const tooltipHover = <HTMLElement>document.getElementsByTagName("db-info-tooltip")[0] || <HTMLElement>document.getElementsByTagName("db-info-tooltip-hover")[0];
            if (tooltipHover !== null && !TypeUtils.isUndefined(tooltipHover)) {
                tooltipHover.innerHTML = "";
            }
            // });
        }
    }

    public setToggle(toggleSidebar) {
        this.toggleSidebar = toggleSidebar;
        this.sidebarNavigationService.toggleSidebar(toggleSidebar);
    }

    public showSmallScreenDisclaimerDialog(userLocalStorage): void {
        this._dialogService.addDialog(SmallScreenDisclaimerDialogComponent).subscribe(() => {
            this._userService.setToLocal({...userLocalStorage, hideDisclaimer: true});
        });
    }

    public acceptInvitationExcistingClients(): void {
        if (this.invitationData) {
            if (this.user.email.toLowerCase() !== this.invitationData.client_email.toLowerCase()) {
                if (this.invitationData.client_id) {
                    this.switchToWorkspace(this.invitationData.workspace_id);
                    this.invitationData = null;
                    /*link without sign-up*/
                    this._authService.logout(`/login?invitation_data=${this.invitationDataUnEncoded}`, this.user.id, null);
                } else {
                    /*link with checkout*/
                    this.invitationData = null;
                    const productParams = this.invitationProductId && this.invitationPeriod
                        ? `product_id=${this.invitationProductId}&period=${this.invitationPeriod}&`
                        : '';
                    this._authService.logout(`/checkout?${productParams}&invitation_data=${this.invitationDataUnEncoded}`, this.user.id, this.userSubscriptionIds.INVITED);
                }
            } else {
                if (!localStorage.getItem('dbFromInvitation') && this.invitationData.workspace_invitation_id) {
                    this.acceptWorkspaceInvitation();
                } else {
                    this.invitationData = null;
                    localStorage.removeItem('dbFromInvitation');
                }
            }
        }
    }

    private _updateMetaTags(): void {
        this._store.select(fromStore.getCompanyInfoLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => this._store.select(fromStore.getCompanyInfo)),
                first()
            )
            .subscribe((companyInfo: any) => {
                // Set companyInfo in the shared service
                this._builderInteractionsService.companyInfo.next(companyInfo);

                if (companyInfo && companyInfo.agency) {
                    const domain = companyInfo.agency.domain || window.location.hostname;
                    const companyName = companyInfo.branding?.company_name || companyInfo.agency?.name || 'Dashboard';

                    // Update title
                    this._title.setTitle(`Create an Account - ${companyName}`);

                    // Update meta tags
                    this._meta.updateTag({name: 'title', content: 'Create an Account'});
                    this._meta.updateTag({
                        name: 'description',
                        content: 'Create your profile and get access to AI website building.'
                    });

                    // Update Open Graph tags
                    this._meta.updateTag({property: 'og:title', content: 'Create an Account'});
                    this._meta.updateTag({
                        property: 'og:description',
                        content: 'Create your profile and get access to AI website building.'
                    });
                    this._meta.updateTag({property: 'og:url', content: `https://${domain}`});
                    this._meta.updateTag({property: 'og:type', content: 'website'});

                    // Update Twitter tags
                    this._meta.updateTag({name: 'twitter:title', content: 'Create an Account'});
                    this._meta.updateTag({
                        name: 'twitter:description',
                        content: 'Create your profile and get access to AI website building.'
                    });
                    this._meta.updateTag({name: 'twitter:card', content: 'summary_large_image'});

                    // Update favicon
                    if (companyInfo.branding?.cache_favicon) {
                        this._updateFavicon(companyInfo.branding.cache_favicon);
                    }
                    // If no cache_favicon, keep the default favicon.ico from index.html
                }
            });
    }

    private _updateFavicon(faviconUrl: string): void {
        // Remove existing favicon links
        const existingLinks = document.querySelectorAll('link[rel*="icon"]');
        existingLinks.forEach(link => link.remove());

        // Add new favicon link
        const link: HTMLLinkElement = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/x-icon';
        link.href = faviconUrl;
        document.head.appendChild(link);
    }

    private _createCookie(newExperiment, setExistingValues: any = null): void {
        if (window.top === window.self) {
            const nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
            const cookieOptions = {path: '/', domain: '10web.io', 'expires': nextYear};
            const serializedValues = Utils.createParticularCookie(newExperiment, setExistingValues);
            this._cookieService.put('db-experiment', serializedValues, cookieOptions);
        }
    }

    private _setCookieWithMultipleValues(experiment, setOldValues: boolean) {
        // if (window.location.hostname !== 'localhost') {
        // delete a cookie with "my.10web.io" domain
        // document.cookie = 'db-experiment' + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        // }
        this.getExperimentalCookie = setOldValues ? this._cookieService.get('db-experiment') : null;
        if (TypeUtils.isUndefined(this.getExperimentalCookie)) {
            this._createCookie(experiment);
        } else {
            if (!TypeUtils.isValidJSON(this.getExperimentalCookie)) {
                this._cookieService.remove('db-experiment');
                this._createCookie(experiment);
            } else if (TypeUtils.isValidJSON(this.getExperimentalCookie)) {
                this._createCookie(experiment, this.getExperimentalCookie);
            }
        }
    }

    private _setLocalTier1(tier1value): void {
        if (!!this.userLocalStorage['tier1B']) return;

        this.userLocalStorage['tier1B'] = tier1value === 'b';
        this._userService.setToLocal(this.userLocalStorage)
            .pipe(
                first(response => !!response),
            )
            .subscribe(response => {
                if (response.success) {
                    this._store.dispatch(new fromStore.LoadUserLocalStorage());
                }
            });
    }

    private _checkUrlForVerification(): void {
        const verifyEmail = window.location.href.indexOf("email") > -1 && window.location.href.indexOf("token") > -1;
        if (!!verifyEmail) {
            const urlParams = new URLSearchParams(window.location.search);
            this._verifyEmail(urlParams.get('token'), urlParams.get('email'));
        }
    }

    private _removeFromCookieValue(getExperimentalCookie, key, setOldValue) {
        const updatedCookie = Utils.removeParticularExperiment(getExperimentalCookie, [key]);
        this._setCookieWithMultipleValues(updatedCookie, setOldValue);
    }

    private _verifyEmail(token, email) {
        this._authService.verifyEmail(token, email)
            .pipe(
                filter((response: DbResponse): boolean => !!response),
                first())
            .subscribe((response) => {
                if (response.success) {
                    this._store.dispatch(new fromStore.LoadUser);
                }
            });
    }

    private _showCycleChangedSuccess(queryParams, annualPrice): void {
        const switchCycle = window.location.href.indexOf("switch_cycle") > -1 || !!queryParams.switch_cycle;
        if (switchCycle) {
            if (!this._dialogService.hasOpenedDialog() && !this._dbModalService.hasOpenModals()) {
                this._dialogService.addDialog(NotificationDialogComponent, {
                    header: 'Billing cycle changed successfully',
                    message: TextUtils.getText('text_switchToAnnualSuccessDesc', {
                        date: Utils.formatDate(this.userSubscription.nextBillingDate, 'dd MMM, y'),
                        price: annualPrice
                    }),
                    width: 700,
                    buttonText: 'Got It',
                    buttonColor: 'black',
                    buttonAlign: 'right',
                    hasCloseButton: true,
                    hasGradientBorder: true,
                    textAlign: 'left'
                });
            }
        }
    }

    private _showSwitchPlanToAnnualDialog(queryParams): void {
        const switchPlanAndUpgrade = window.location.href.indexOf("switch_plan") > -1 || queryParams.switch_plan;
        if (switchPlanAndUpgrade) {
            if (!this._dialogService.hasOpenedDialog() && !this._dbModalService.hasOpenModals()) {
                this._showSuccessfullyUpgradedDialog();
            }
        }

    }

    private _showSuccessfullyUpgradedDialog(): void {
        this._sendGaEvent();
        const shownText = this.userSubscription && this.userSubscription.isBusiness
            ? 'Congratulations! Your upgrade to the AI Ultimate Annual plan<br/> has been successfully processed.'
            : 'Congratulations! Your upgrade to the AI Ecommerce Premium Annual plan<br/> has been successfully processed.';
        this._dialogService.addDialog(NotificationDialogComponent, {
            header: 'Successfully upgraded to an annual plan',
            message: shownText,
            width: 700,
            buttonText: 'Got It',
            buttonColor: 'black',
            buttonAlign: 'right',
            hasCloseButton: true,
            hasGradientBorder: true,
            textAlign: 'left'
        });
    }

    private _sendGaEvent(): void {
        const analyticsData = {
            eventCategory: 'Dashboard Action',
            eventAction: 'Upgrade to Annual flow',
            eventLabel: 'Checkout Completed'
        };
        this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    }

    private _getOngoingOptimizingActivities() {
        this.ongoingActivity$ = this._store.select(fromStore.getOngoingActivities);
        this.ongoingActivity$
            .subscribe((ongoingActivities): void => {
                const activity = ongoingActivities.find(({action}) => action === ActivityAction.OPTIMIZING_FIRST_PAGE);
                if (activity && !this.ongoingBoosterActivity) {
                    this.ongoingBoosterActivity = true;
                    return this._showBoosterOptimizationDialog(activity.websiteId, activity.status === ActivityStatus.DONE);
                }
            });
    }

    private _getConnectionFlowStep(websiteId): void {
        !!websiteId && this._performanceService.getConnectionFlowProgress(websiteId)
            .pipe(
                first(response => !!response, null),
            )
            .subscribe(response => {
                if (response.success) {
                    const steps = response.data && response.data.steps ? response.data.steps : [];
                    if (steps.length) {
                        this._showBoosterOptimizationDialog(websiteId);
                    }
                }
            });
    }

    private _openLiveChat(): void {
        this.openLiveChat = window.location.href.indexOf("open=livechat") > -1;
        this.sendChatMessage = window.location.href.indexOf("flow_contact_us") > -1;
        if (this.sendChatMessage) {
            this.sendMessage = 'I need help with 10Web Booster Optimization.';
            this.sendTag = 'booster_flow';
        }
    }

    private _showDownloadPluginsDialog(): void {
        this._store.select(fromStore.getTenWebProductsLoaded)
            .pipe(
                filter(loaded => loaded),
                first()
            )
            .subscribe(() => {
                this._store.select(fromStore.getTenWebProducts)
                    .pipe(
                        first()
                    )
                    .subscribe(products => {
                        this._unavailableDialog(products);
                    });
            });
    }

    private _unavailableDialog(products: Product[]): void {
        this._dialogService.addDialog(UnavailableDialogComponent, {
            header: TextUtils.getText('text_unavailablePluginDownload.bundleTitle'),
            plugins: products.filter(product => product.slug !== Config.optimizerPluginSlug),
            fromLocal: 'fromLocal',
            userSubscription: this.userSubscription.type
        });
    }

    private emailVerification(queryParams): void {
        const emailVerified: number = parseInt(queryParams.db_success, 10);
        if (emailVerified) {
            this._dialogService
                .addDialog(EmailVerificationComponent, {
                    type: 'fromSuccess'
                })
                .subscribe((confirmed: boolean): void => {
                    if (confirmed) {
                        this._store.dispatch(new fromStore.LoadUser);
                    }
                });
        }
    }

    private showWhatsNewDialog(user): void {
        const pageId = /[^/]*$/.exec(window.location.href)[0];

        if (!['checkout', 'sign-up', 'login', 'reset-password', 'forgot-password'].includes(pageId)) {
            this._websiteService.getWhatsNewIsClient()
                .pipe(
                    filter((response: DbResponse): boolean => !!response),
                    first()
                )
                .subscribe((response: DbResponse): void => {
                    if (response.success && response.data && response.data.id) {
                        this._dialogService.addDialog(WhatsNewDialogComponent, {
                            user: user,
                            data: response.data
                        });
                    }
                });
        }
    }

    private migrationSuccessDataMapper(websites): void {
        const connected = websites && websites.length && websites.find((website: Website) => !website.parentId && !website.isNetwork && !website.isLocalhost && website.isActive && website.type === 'live' && !website.domain_hash);
        const migrated = this.userSubscription && this.userSubscription.trialClient && websites.find((website: Website) => website.migrated_from && connected && website.migrated_from.replace(/(^\w+:|^)\/\//, '') === connected.site_url.replace(/(^\w+:|^)\/\//, ''));
        if (!migrated || (migrated && this.userLocalStorage && this.userLocalStorage['hideMigrationSuccess' + migrated.id])) {
            return;
        }
        const oldWebsiteData = connected && {
            score: connected.score && connected.score.currentScore && connected.score.currentScore.desktopScore || null,
            desktopTTI: connected.score && connected.score.currentScore && connected.score.currentScore.desktopTTI || null,
            mobileScore: connected.score && connected.score.currentScore && connected.score.currentScore.mobileScore || null,
            mobileTTI: connected.score && connected.score.currentScore && connected.score.currentScore.mobileTTI || null,
        } || null;
        const newWebsiteData = migrated && {
            score: migrated.score && migrated.score.currentScore && migrated.score.currentScore.desktopScore || null,
            desktopTTI: migrated.score && migrated.score.currentScore && migrated.score.currentScore.desktopTTI || null,
            mobileScore: migrated.score && migrated.score.currentScore && migrated.score.currentScore.mobileScore || null,
            mobileTTI: migrated.score && migrated.score.currentScore && migrated.score.currentScore.mobileTTI || null,
            websiteId: migrated.id
        } || null;
        if (migrated && oldWebsiteData && newWebsiteData) {
            const modal = this._dbModalService.open(MigrationSuccessDialogComponent);
            modal.componentInstance.oldData = oldWebsiteData;
            modal.componentInstance.newData = newWebsiteData;
        }
    }

    private acceptWorkspaceInvitation() {
        this._userManagementService.acceptInvitation(this.invitationData.workspace_invitation_id)
            .pipe(
                filter((response: DbResponse): boolean => !!response),
                first()
            )
            .subscribe((response) => {
                /* in case of expired response success but with other status */
                if (response.success) {
                    this._store.dispatch(new fromStore.LoadUser());
                    const switchToWorkspace = {
                        ownerWorkspaceId: +localStorage.getItem('dbOwnWorkspaceId'),
                        currentWorkspaceId: this.invitationData.workspace_id,
                        currentWorkspaceRoleId: this.invitationData.role_id
                    };
                    this.switchToWorkspace(this.invitationData.workspace_id, switchToWorkspace);
                } else {
                    NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
                }
                this.invitationData = null;
                localStorage.removeItem('dbFromInvitation');
            });
    }

    private _showBoosterOptimizationDialog(websiteIdConnected: number, success = false): void {
        if (!this._dbModalService.hasOpenModals()) {
            const modal = this._dbModalService.open(OptimizationDialogComponent, {
                hasCloseBtn: false,
                backdrop: 'static'
            });
            modal.componentInstance.websiteId = websiteIdConnected;
            modal.componentInstance.userSubscription = this.userSubscription;
            modal.componentInstance.user = this.user;
            modal.componentInstance.success = success;
        }
    }

    private _showExceededDialog(): void {
        if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
            return this._showCheckoutDialog();
        }
        if (this.currentWorkspace && this.currentWorkspace.roleId
            && ![clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspace.roleId)
            && this.userSubscription && this.userSubscription.recharge) {
            return this._showRechargeDialog();
        }
        this._createWebsiteService.openLimitExceededModal();
    }

    private _showCheckoutDialog(): void {
        this._sendAnalytics('Free Upgrade Offer', 'Locked button click', 'Migrate');
        const modal = this._dbModalService.open(OneMonthFreeComponent, {height: 600, width: 940});
        modal.componentInstance.mode = 'creation';
    }

    private _sendAnalytics(category, action, label, websiteId = null): void {
        let analyticsData = {
            eventCategory: category,
            eventAction: action,
            eventLabel: label
        };

        if (!TypeUtils.isNull(websiteId)) {
            analyticsData = Object.assign({}, analyticsData, {
                websiteId: websiteId,
            });
        }

        this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
    }

    private _showRechargeDialog(): void {
        const modal = this._dbModalService.open(RechargeComponent, {height: 208, width: 700});
        modal.componentInstance.userSubscription = this.userSubscription;
    }

    private _hostingAddOnDialogShow(websites): void {
        const modal = this._dbModalService.open(InformativeDialogComponent, {hasCloseBtn: true, backdrop: 'static'});
        modal.componentInstance.title = TextUtils.getText("text_hostingIsAvailableTitle");
        modal.componentInstance.eventAction = 'Introducing Hosting Add-on';
        modal.componentInstance.eventLabel = 'Hosting Add-on';
        modal.componentInstance.description = TextUtils.getText("text_hostingIsAvailableDesc");
        modal.componentInstance.button = {
            color: 'ds-btn-green',
            size: 'ds-btn-xl',
            text: TextUtils.getText("text_buyHosting")
        };
        modal.componentInstance.features = this.hostingAddOnFeatures;
        modal.componentInstance.sizes = {height: 600, width: 940};
        modal.componentInstance.rightImage = "assets/images/backgrounds/hosting-features-dialog.png";
        modal.componentInstance.websiteId = websites && websites[0] && websites[0].id || null;

        modal.closed.subscribe(() => {
            const analyticsData = {
                eventCategory: 'Dashboard Action',
                eventAction: 'Buy now button (Introducing Hosting Add-on pop-up)',
                eventLabel: 'Hosting add-on',
                websiteId: websites && websites[0] && websites[0].id || null
            };
            this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
            this._dialogService.addDialog(PaymentDialogComponent, {
                upgradeSubscription: this.userSubscription,
                fromDialog: true,
                renew: false,
                showAdditional: true,
                fromHosting: true,
                extend: false,
                buyCdnAddOn: false,
                websiteId: websites && websites[0] && websites[0].id || null
            });
        });
    }

    private loginFromMagicLink(token, email, path, queryParams, googleRecaptcha = null): void {
        const data = {
            "magic_token": token,
            "email": email
        };
        this._authService.login(data, false, googleRecaptcha)
            .pipe(filter((response: DbResponse): boolean => !!response),
                first())
            .subscribe((response) => {
                if (response.success) {
                    this._router.navigate([path], {queryParams});
                }
            });
    }

    private _checkStorageIframeOpened(): boolean {
        return !!sessionStorage.getItem('iframeOpened');
    }

    private _showUpgradePopupForWpAdmin(): void {
        const modal = this._dbModalService.open(OneMonthFreeComponent, {height: 600, width: 940});
        modal.componentInstance.mode = 'general';
    }

    private _downgradeToStarterPlan(downgradeTo: string): void {
        this._authService.downgradeAgreement(downgradeTo)
            .pipe(
                first(response => !!response, null)
            )
            .subscribe((response) => {
                if (response.success) {
                    this.downgradedToBase = true;
                    const analyticsData = {
                        eventCategory: 'Dashboard Action',
                        eventAction: 'Resurrection',
                        eventLabel: 'Expired Free Plan - logged-in'
                    };
                    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
                }
            });
    }
}
